class FieldsetVisibility {
  constructor() {
    // Tracks already processed input elements
    this.handled = new WeakSet();

    // Set up change listener
    this.setListeners();

    // Initialize existing elements on page load
    this.init();
  }

  // Attach global change listener to monitor input state changes
  setListeners() {
    document.addEventListener("change", event => {
      const input = event.target.closest("input");
      if (!input || !["checkbox", "radio"].includes(input.type)) return;
      this.applyTo(input);
    });
  }

  // Initialize all checkbox and radio inputs found on the page
  init() {
    const inputs = document.querySelectorAll("input[type='checkbox'], input[type='radio']");
    inputs.forEach(input => this.applyTo(input));
  }

  // Apply logic to newly added inputs that haven't been processed yet
  bindNew() {
    const inputs = document.querySelectorAll("input[type='checkbox'], input[type='radio']");
    inputs.forEach(input => {
      if (!this.handled.has(input)) {
        this.applyTo(input);
      }
    });
  }

  // Determine and apply fieldset state based on input type
  applyTo(input) {
    this.handled.add(input);

    if (input.type === "checkbox") {
      this.setStateByCheckbox(input);
    } else if (input.type === "radio") {
      this.setStateByRadio(input);
    }
  }

  // Toggle fieldset linked to checkbox by matching [data-relative=ID]
  setStateByCheckbox(input) {
    const id = input.id;
    if (!id) return;

    const fieldset = document.querySelector(`[data-relative='${CSS.escape(id)}']`);
    if (!fieldset) return;

    fieldset.disabled = !input.checked;
  }

  // Toggle all related fieldsets for a group of radio inputs
  setStateByRadio(input) {
    const name = input.name;
    if (!name) return;

    const radios = document.querySelectorAll(`input[type='radio'][name='${CSS.escape(name)}']`);
    radios.forEach(radio => {
      const id = radio.id;
      if (!id) return;

      const fieldset = document.querySelector(`[data-relative='${CSS.escape(id)}']`);
      if (!fieldset) return;

      fieldset.disabled = !radio.checked;
    });
  }
}

export default FieldsetVisibility;
